// Consumes /api/sections and exposes { key -> enabled } for public gating.
// Rule: a section is considered ENABLED unless the API explicitly returned false
// for its key. This avoids flash-hide before the fetch completes.
import { useEffect, useState } from "react";
import { api } from "@/lib/api";

let _cache = null;
let _promise = null;
const _listeners = new Set();

async function _fetch() {
  if (_cache) return _cache;
  if (!_promise) {
    _promise = api
      .get("/sections")
      .then((r) => {
        const map = {};
        (r.data || []).forEach((s) => { if (s && s.key) map[s.key] = !!s.enabled; });
        _cache = map;
        return map;
      })
      .catch(() => { _cache = {}; return _cache; });
  }
  return _promise;
}

// Re-fetch when the tab becomes visible again so admin toggles propagate.
if (typeof document !== "undefined" && !window.__hawkam_sections_bound) {
  window.__hawkam_sections_bound = true;
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") {
      _cache = null;
      _promise = null;
      _fetch().then((m) => _listeners.forEach((fn) => fn(m)));
    }
  });
}

export function useSections() {
  const [state, setState] = useState(_cache || {});
  useEffect(() => {
    _fetch().then(setState);
    _listeners.add(setState);
    return () => _listeners.delete(setState);
  }, []);
  return state;
}

// True unless the admin has explicitly disabled the section.
export function isSectionOn(sections, key) {
  return sections?.[key] !== false;
}
